var View = require('views/base/view');
var BlocksView = require('views/block/block-collection-view');
var FeedbackService = require('services/feedback-service');
var AnimationService = require('services/animation-service');
var utils = require('lib/utils');

var MenuView = View.extend({
  autoRender: true,
  className: 'menu',
  template: require('./templates/menu'),
  listen:{
    'block:feedback mediator': 'renderFeedback'
  },
  listSelector: '.menu-items',
  animationDuration: 0,
  regions: {
    'blocks': '.blocks',
    feedback: '.feedback'
  },
  initialize: function(options) {
    this.subView = options.subView;
    if(!options.subView){
      Chaplin.mediator.publish('page:state:initialized', this);
    }
    this.script = utils.tryRequire('menu/' + this.model.get('key') + '/' + this.model.get('key')) || {};
    if(this.script.initialized) {
      this.script.initialized.call(this.script, this);
    }
    this.on('addedToDOM', _.bind(this.renderBlocks, this));
    View.prototype.initialize.apply(this, arguments);
  },
  renderBlocks: function() {
    this.delegate('click', '[data-close=true]', (e) => {
      e.preventDefault();
      this.trigger('close', this);
    });
    const blocksLoaded = () => {
      if(!this.subView){
        Chaplin.mediator.publish('page:state:loaded', this);
      }
      if(this.script.loaded) {
        this.script.loaded.call(this.script, this);
      }
      AniJS.run();
      if(this.model.get('startAnimation')) {
        AnimationService.queueAnimationsRun();
      }
      this.model.set('state', 'playing');
      this.trigger('page:state:change', this);
    };
    if(this.model.get('blocks')) {
      var blocksView = new BlocksView({
        collection: this.model.get('blocks'),
        region: 'blocks',
        script: this.script ? this.script.block : undefined,
        parent: this
      });
      this.subview('blocks', blocksView);
      const readyToLoad = () => blocksView.isLoaded();
      if(blocksView.isLoaded()) {
        blocksLoaded();
      } else {
        this.listenTo(blocksView, 'block:state:loaded', () => blocksLoaded());
      }
    } else {
      blocksLoaded();
    }
  },
  renderFeedback: function(feedback, callbacks) {
    FeedbackService.displayFeedback(this, feedback, callbacks);
  },
  dispose: function() {
    $('#page-loading')
      .attr('aria-hidden', false)
      .focus();
    if(this.script.unloading) {
      this.script.unloading.call(this.script, this, function() {});
    }
    View.prototype.dispose.apply(this, arguments);
  }
});

module.exports = MenuView;
